
import { defineComponent } from 'vue'
import { useLayoutModule } from '@/modules/layout'
import LayoutMenuItem from '@/components/layout/menu-item.vue'
import {
    OrganizationsRouteNames,
    PackagesRouteNames,
    AgreementsRouteNames,
    MembersRouteNames,
    JobTitlesRouteNames,
    FreeFormsRouteNames,
    FreeSubscriptionsRouteNames,
    ElectronicOperatorsRouteNames
} from '@/router/routes-names'

export default defineComponent({
    name: 'layout-left-menu',
    components: { LayoutMenuItem },
    setup () {
        const { menu } = useLayoutModule()
        return {
            menu,
            OrganizationsRouteNames,
            PackagesRouteNames,
            AgreementsRouteNames,
            MembersRouteNames,
            JobTitlesRouteNames,
            FreeFormsRouteNames,
            FreeSubscriptionsRouteNames,
            ElectronicOperatorsRouteNames
        }
    }

})
